import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const ToBottom24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M12.0477 19C12.3985 19 12.6992 18.8488 12.8996 18.5967L17.7606 13.0515C18.1114 12.6986 18.0613 12.0937 17.7105 11.7408C17.3597 11.3879 16.7584 11.4383 16.4076 11.7912C16.4076 11.7912 16.4076 11.7912 16.3575 11.8416L12.0978 16.6811C12.0477 16.7315 11.9976 16.7315 11.8974 16.6811L7.63776 11.8416C7.28696 11.4383 6.73572 11.3879 6.33481 11.7408C5.93391 12.0937 5.88379 12.6482 6.23459 13.0515C6.23459 13.0515 6.23459 13.0515 6.2847 13.1019L11.1457 18.6471C11.3962 18.8488 11.6969 19 12.0477 19Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M12.0477 12.5C12.3985 12.5 12.6992 12.3488 12.8996 12.0967L17.7606 6.55149C18.1114 6.19861 18.0613 5.59368 17.7105 5.2408C17.3597 4.88792 16.7584 4.93833 16.4076 5.29121C16.4076 5.29121 16.4076 5.29121 16.3575 5.34162L12.0978 10.1811C12.0477 10.2315 11.9976 10.2315 11.8974 10.1811L7.63776 5.34162C7.28696 4.93833 6.73572 4.88792 6.33481 5.2408C5.93391 5.59368 5.88379 6.1482 6.23459 6.55149C6.23459 6.55149 6.23459 6.55149 6.2847 6.6019L11.1457 12.1471C11.3962 12.3488 11.6969 12.5 12.0477 12.5Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
